import { render } from "./PenandatanganSelect.vue?vue&type=template&id=09d566d5&scoped=true"
import script from "./PenandatanganSelect.vue?vue&type=script&lang=js"
export * from "./PenandatanganSelect.vue?vue&type=script&lang=js"

import "./PenandatanganSelect.vue?vue&type=style&index=0&id=09d566d5&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d566d5"]])

export default __exports__